export default {
    accountApps_name: 'Nombre',
    accountApps_apiKey: 'API Key',
    accountApps_status: 'Estado',
    accountApps_search: 'Buscar',
    accountApps_add: 'Agregar integración',
    accountApps_deleteOne: 'Eliminar integración',
    accountApps_deleteMany: 'Eliminar _COUNT_ integraciones',
    accountApps_deleteSelect: 'Seleccione una integración para eliminar',
    accountApps_noItems: 'No hay elementos.',
    accountApps_footer: 'No hay más elementos. · _COUNT_ integraciones',
    accountApps_footerOne: 'No hay más elementos. · 1 integración',
    accountApps_footerMatch: '_MATCH_ de _COUNT_ integraciones coinciden.',
    accountApps_noMatch: 'Ninguna integración coincide con “_SEARCH_”.',
    accountApps_clearSearch: 'Limpiar búsqueda',
    accountApps_copyKey: 'Copiar API Key',
    accountApps_copied: 'Copiada',
    accountApps_copyError: 'No se pudo copiar la API Key. Inténtelo de nuevo.',
    accountApps_active: 'Activa',
    accountApps_inactive: 'Inactiva',
    accountApps_pillActive: 'Integración activa',
    accountApps_pillSyncs: 'Activa: los vehículos se sincronizan a diario con _APP_',
    accountApps_pillInactiveTip: 'Inactiva: no sincroniza vehículos ni transmite',
    accountApps_transmittingLast: 'Transmitiendo · última _TIME_',
    accountApps_lastTransmission: 'Última transmisión _TIME_',
    accountApps_noTransmissions: 'Sin transmisiones todavía',
    accountApps_telemetryTip: 'Hoy en _TZ_: _SENT_ transmisiones · _ERRORS_ errores.',
    accountApps_linked: '_COUNT_ vehículos vinculados',
    accountApps_linkedOne: '1 vehículo vinculado',
    accountApps_openLinked: 'Abrir vehículos vinculados',
    accountApps_syncing: 'Sincronizando vehículos',
    accountApps_syncingCount: 'Sincronizando vehículos · _COUNT_ leídos',
    accountApps_syncDone: 'Sincronización de vehículos completada. _COUNT_ vehículos están vinculados con _APP_.',
    accountApps_syncDoneOne: 'Sincronización de vehículos completada. 1 vehículo está vinculado con _APP_.',
    accountApps_syncFailed: 'No se pudo completar la sincronización de vehículos con _APP_. Inténtelo más tarde.',
    accountApps_syncSlow: 'La sincronización de vehículos con _APP_ está tardando más de lo esperado. Los vehículos vinculados aparecerán cuando termine.',
    accountApps_syncSlowTitle: 'Sincronización en curso',
    accountApps_deleted: 'Integración eliminada',
    accountApps_deletedMany: '_COUNT_ integraciones eliminadas',
    accountApps_deleteTitle: 'Eliminar integraciones',
    accountApps_deleteWarning: '¿Está seguro de que desea eliminar las siguientes integraciones? _PRODUCT_ deja de transmitirles los movimientos de los vehículos.',
    accountApps_updated: 'Integración actualizada correctamente',

    accountAppsWizard_title: 'Nueva integración',
    accountAppsWizard_close: 'Cerrar',
    accountAppsWizard_selectApp: 'Seleccione una aplicación para ver los pasos de esa conexión.',
    accountAppsWizard_rowPreview: 'Vista previa de la fila',
    accountAppsWizard_rowPreviewSub: 'Esta fila se agrega a Aplicaciones cuando termine.',
    accountAppsWizard_stepApp: 'Aplicación',
    accountAppsWizard_stepAppSub: 'Elija a dónde van los datos',
    accountAppsWizard_stepKey: 'API Key',
    accountAppsWizard_stepKeySub: 'Lo único que necesitamos',
    accountAppsWizard_stepVerify: 'Cargar catálogo',
    accountAppsWizard_stepVerifySub: 'Verificar la conexión',
    accountAppsWizard_stepSync: 'Finalizar',
    accountAppsWizard_stepSyncSub: 'Los vehículos se cargan en segundo plano',
    accountAppsWizard_pickTitle: 'Amplíe _PRODUCT_',
    accountAppsWizard_pickSub: 'Conecte _PRODUCT_ con las aplicaciones que su flota necesita para optimizar sus procesos.',
    accountAppsWizard_appAvailable: '1 aplicación disponible',
    accountAppsWizard_appsAvailable: '_COUNT_ aplicaciones disponibles',
    accountAppsWizard_appsConnected: ' · _COUNT_ conectadas',
    accountAppsWizard_searchApps: 'Buscar aplicaciones',
    accountAppsWizard_noApps: 'Ninguna aplicación coincide con “_SEARCH_”.',
    accountAppsWizard_noAppsAvailable: 'No hay aplicaciones disponibles para conectar.',
    accountAppsWizard_loadingApps: 'Cargando aplicaciones…',
    accountAppsWizard_appsError: 'No se pudieron cargar las aplicaciones.',
    accountAppsWizard_keyTitle: 'Ingrese su API Key de _APP_',
    accountAppsWizard_keySub: 'Es todo lo que necesitamos. La integración se llama _APP_ e inicia como Activa.',
    accountAppsWizard_keyPlaceholder: 'API Key',
    accountAppsWizard_keyRequired: 'La API Key es requerida',
    accountAppsWizard_keyHint: 'Pegue la API Key exactamente como la muestra _APP_. No se aplica ningún formato.',
    accountAppsWizard_showKey: 'Mostrar API Key',
    accountAppsWizard_hideKey: 'Ocultar API Key',
    accountAppsWizard_verify: 'Verificar',
    accountAppsWizard_verifying: 'Verificando…',
    accountAppsWizard_verified: 'Verificada',
    accountAppsWizard_keyAccepted: '_APP_ aceptó esta API Key. Haga clic en Siguiente para continuar.',
    accountAppsWizard_keyAcceptedAccount: '_APP_ aceptó esta API Key para _ACCOUNT_. Haga clic en Siguiente para continuar.',
    accountAppsWizard_keyRejected: '_APP_ rechazó esta API Key. Revísela y verifíquela de nuevo.',
    accountAppsWizard_keyStale: 'La API Key cambió desde que se verificó. Verifíquela de nuevo.',
    accountAppsWizard_keyUnreachable: 'No se pudo conectar con _APP_. Revise su conexión e inténtelo de nuevo.',
    accountAppsWizard_verifyTitleRunning: 'Verificando conexión…',
    accountAppsWizard_verifyTitleDone: 'Conexión verificada',
    accountAppsWizard_verifyTitleFailed: 'La conexión falló',
    accountAppsWizard_verifySub: 'Revisando la conexión antes de guardar cualquier cosa.',
    accountAppsWizard_checkReach: 'Conectando con la API de _APP_',
    accountAppsWizard_checkAuth: 'Autenticando la API Key',
    accountAppsWizard_checkPassed: 'APROBADO',
    accountAppsWizard_checkFailed: 'FALLÓ',
    accountAppsWizard_checkChecking: 'REVISANDO',
    accountAppsWizard_checkPending: 'PENDIENTE',
    accountAppsWizard_failNet: 'No se pudo conectar con _APP_ (se agotó el tiempo de conexión). Revise su conexión e inténtelo de nuevo.',
    accountAppsWizard_failAuth: '_APP_ rechazó esta API Key. Revísela e inténtelo de nuevo.',
    accountAppsWizard_failVehicles: '_APP_ aceptó esta API Key, pero no puede leer los vehículos de la flota. Revise los permisos de la API Key en _APP_ e inténtelo de nuevo.',
    accountAppsWizard_keyNoVehicles: '_APP_ aceptó esta API Key, pero no puede leer los vehículos de la flota. Revise sus permisos y verifíquela de nuevo.',
    accountAppsWizard_checkVehicles: 'Verificando el acceso a los vehículos',
    accountAppsWizard_checkVehiclesNone: 'SIN VEHÍCULOS',
    accountAppsWizard_checkVehiclesUnknown: 'NO VERIFICADO',
    accountAppsWizard_noVehiclesWarning: '_APP_ todavía no tiene vehículos en esta flota: la sincronización no vinculará ninguno hasta que los haya.',
    accountAppsWizard_vehiclesUnknownWarning: 'La API Key funciona, pero _APP_ no respondió la verificación de vehículos a tiempo. Puede continuar: la sincronización lee los vehículos después.',
    accountAppsWizard_syncTitle: 'Listo para sincronizar sus vehículos',
    accountAppsWizard_syncSub: 'Sincronizaremos los vehículos que tiene habilitados para la integración en _APP_. Puede tomar unos minutos. Le notificaremos cuando el proceso termine.',
    accountAppsWizard_syncSaved: 'Integración guardada',
    accountAppsWizard_syncSavedSub: 'Fila de _APP_ agregada con estado Activa',
    accountAppsWizard_syncVehicles: 'Sincronización de vehículos',
    accountAppsWizard_syncVehiclesSub: 'Vehículos activos habilitados para la integración en _APP_. Corre en segundo plano, unos minutos.',
    accountAppsWizard_syncNotification: 'Notificación',
    accountAppsWizard_syncNotificationSub: 'Abra sus vehículos vinculados desde ella',
    accountAppsWizard_cancel: 'Cancelar',
    accountAppsWizard_back: 'Atrás',
    accountAppsWizard_next: 'Siguiente',
    accountAppsWizard_continue: 'Continuar',
    accountAppsWizard_finish: 'Finalizar',
    accountAppsWizard_retry: 'Reintentar',
    accountAppsWizard_editKey: 'Editar API Key',
    accountAppsWizard_connected: '_APP_ conectada. La integración está Activa.',
    accountAppsWizard_alreadyConnected: 'Ya está conectada',
    accountAppsWizard_connect: 'Conectar _APP_',

    accountAppsMenu_options: 'Opciones de la integración',
    accountAppsMenu_edit: 'Editar integración',
    accountAppsMenu_linkedVehicles: 'Vehículos vinculados',
    accountAppsMenu_linkedVehiclesLocked: 'Disponible cuando termine la sincronización',

    accountAppsEdit_title: 'Editar la integración con _APP_',
    accountAppsEdit_close: 'Cerrar',
    accountAppsEdit_name: 'Nombre',
    accountAppsEdit_keyHint: 'Haga clic en el campo y pegue una API Key nueva para reemplazar la actual. Las API Keys nuevas deben verificarse antes de guardar.',
    accountAppsEdit_keyAccepted: '_APP_ aceptó esta API Key. Ya puede guardar.',
    accountAppsEdit_keyAcceptedAccount: '_APP_ aceptó esta API Key para _ACCOUNT_. Ya puede guardar.',
    accountAppsEdit_status: 'Estado',
    accountAppsEdit_info: 'Cuando el estado es Inactiva, _PRODUCT_ deja de transmitir los movimientos de los vehículos a _APP_. El log de transmisiones se conserva 7 días.',
    accountAppsEdit_cancel: 'Cancelar',
    accountAppsEdit_save: 'Guardar',
    accountAppsEdit_saving: 'Guardando…',

    accountAppsConsole_title: 'Vehículos vinculados con _APP_',
    accountAppsConsole_sub: 'Vista en vivo · se actualiza mientras esta ventana está abierta',
    accountAppsConsole_close: 'Cerrar',
    accountAppsConsole_viewLog: 'Ver el log de transmisiones',
    accountAppsConsole_live: 'En vivo',
    accountAppsConsole_idle: 'Sin actividad',
    accountAppsConsole_paused: 'Pausada',
    accountAppsConsole_liveLast: 'última _TIME_',
    accountAppsConsole_idleLast: 'última transmisión _TIME_',
    accountAppsConsole_liveWaiting: 'esperando el primer movimiento',
    accountAppsConsole_pausedInactive: 'la integración está Inactiva',
    accountAppsConsole_secondsAgo: 'hace _N_ s',
    accountAppsConsole_minutesAgo: 'hace _N_ min',
    accountAppsConsole_hoursAgo: 'hace _N_ h',
    accountAppsConsole_kpiLinked: 'Vinculados y activos',
    accountAppsConsole_kpiLinkedTip: 'Transmitiendo a _APP_',
    accountAppsConsole_kpiUnmatched: 'Sin coincidencia',
    accountAppsConsole_kpiUnmatchedTip: 'Ninguna unidad de _PRODUCT_ tiene ese VIN',
    accountAppsConsole_kpiErrors: 'Errores de transmisión hoy',
    accountAppsConsole_kpiErrorsTip: 'Abrir el log filtrado por errores',
    accountAppsConsole_kpiToday: 'Transmisiones hoy',
    accountAppsConsole_kpiTodayTip: 'Enviadas a _APP_ desde la medianoche _TZ_',
    accountAppsConsole_vehicles: 'Vehículos',
    accountAppsConsole_filter_linked: 'Vinculados',
    accountAppsConsole_filter_unmatched: 'Sin coincidencia',
    accountAppsConsole_filter_all: 'Todos',
    accountAppsConsole_search: 'Buscar unidad, nombre o VIN',
    accountAppsConsole_colUnit: 'Unidad',
    accountAppsConsole_colVehicle: 'Vehículo en _APP_',
    accountAppsConsole_colLink: 'Vínculo',
    accountAppsConsole_colLast: 'Última transmisión',
    accountAppsConsole_colToday: 'Hoy',
    accountAppsConsole_notMatched: 'Sin coincidencia',
    accountAppsConsole_link_linked: 'Vinculado',
    accountAppsConsole_link_linkedTip: 'Coincide con una unidad de _PRODUCT_ y está activo en _APP_',
    accountAppsConsole_link_unmatched: 'Sin coincidencia',
    accountAppsConsole_link_unmatchedTip: 'Ninguna unidad de _PRODUCT_ tiene ese VIN',
    accountAppsConsole_link_inactive: 'Inactivo',
    accountAppsConsole_link_inactiveTip: 'Inactivo en _APP_. No se transmite.',
    accountAppsConsole_lastFailed: 'Falló',
    accountAppsConsole_waitingFirst: 'Esperando el primer movimiento',
    accountAppsConsole_notTransmitted: 'No se transmite',
    accountAppsConsole_rowLogTip: 'Ver el log de hoy de _UNIT_',
    accountAppsConsole_noMatch: 'Ningún vehículo coincide',
    accountAppsConsole_clearFilters: 'Limpiar filtros',
    accountAppsConsole_noVehicles: 'Todavía no hay vehículos sincronizados',
    accountAppsConsole_loadError: 'No se pudieron cargar los vehículos.',

    accountAppsLog_title: 'Log de transmisiones',
    accountAppsLog_sub: '_APP_ · se conserva 7 días · horas en _TZ_',
    accountAppsLog_close: 'Cerrar',
    accountAppsLog_download: 'Descargar _RANGE_ en CSV',
    accountAppsLog_downloadErrors: 'Descargar _RANGE_ (solo errores) en CSV',
    accountAppsLog_range_today: 'Hoy',
    accountAppsLog_range_yesterday: 'Ayer',
    accountAppsLog_range_last7days: 'Últimos 7 días',
    accountAppsLog_all: 'Todas',
    accountAppsLog_errors: 'Errores',
    accountAppsLog_clearUnit: 'Mostrar todos los vehículos',
    accountAppsLog_colTime: 'Hora',
    accountAppsLog_colUnit: 'Unidad',
    accountAppsLog_colEvent: 'Evento',
    accountAppsLog_colResponse: 'Respuesta',
    accountAppsLog_eventDefault: 'Telemetría',
    accountAppsLog_odometer: '_MI_ mi',
    accountAppsLog_speed: '_MPH_ mph',
    accountAppsLog_endpoint: 'ENDPOINT',
    accountAppsLog_ok: 'OK',
    accountAppsLog_retry: 'reintento',
    accountAppsLog_error: 'Error',
    accountAppsLog_deliveredTip: 'Entregada en _MS_ ms',
    accountAppsLog_deliveredRetryTip: 'Entregada en _MS_ ms después de _N_ intentos',
    accountAppsLog_errorTip: 'Clic para ver el detalle',
    accountAppsLog_errorCodeTip: '_STATUS_ · clic para ver el detalle',
    accountAppsLog_retriedBackoff: '(reintentada con backoff)',
    accountAppsLog_noResponse: 'Sin respuesta de la aplicación',
    accountAppsLog_attempts: 'INTENTOS',
    accountAppsLog_latency: 'LATENCIA',
    accountAppsLog_vin: 'VIN',
    accountAppsLog_readingTime: 'HORA DE LA LECTURA',
    accountAppsLog_empty: 'No hay transmisiones en este rango',
    accountAppsLog_loadError: 'No se pudieron cargar las transmisiones.',
    accountAppsLog_footerMore: 'Mostrando las últimas _SHOWN_ de _TOTAL_ · descargue el CSV para el rango completo',
    accountAppsLog_footerCount: '_COUNT_ transmisiones · _ERRORS_ errores',
    accountAppsLog_exported: '_COUNT_ transmisiones exportadas',
    accountAppsLog_exportTruncated: 'La exportación se detuvo en _COUNT_ transmisiones. Elija un rango más corto para el resto.',
    accountAppsLog_exportEmpty: 'No hay transmisiones en este rango',
    accountAppsLog_exportError: 'No se pudieron exportar las transmisiones.',
    accountAppsLog_csvTime: 'Hora _TZ_',
    accountAppsLog_csvTimeUtc: 'Hora UTC',
    accountAppsLog_csvUnit: 'Unidad',
    accountAppsLog_csvVin: 'VIN',
    accountAppsLog_csvProviderVehicle: 'ID del vehículo en _APP_',
    accountAppsLog_csvEvent: 'Evento',
    accountAppsLog_csvReadingTime: 'Hora de la lectura UTC',
    accountAppsLog_csvLatitude: 'Latitud',
    accountAppsLog_csvLongitude: 'Longitud',
    accountAppsLog_csvSpeed: 'Velocidad (mph)',
    accountAppsLog_csvOdometer: 'Odómetro (mi)',
    accountAppsLog_csvStatus: 'Estado',
    accountAppsLog_csvHttpStatus: 'Estado HTTP',
    accountAppsLog_csvError: 'Error',
    accountAppsLog_csvAttempts: 'Intentos',
    accountAppsLog_csvLatency: 'Latencia (ms)',

    // Texts of the catalog apps' wizardConfig (fleet.integrations): accountAppsCatalog_<code>_*
    accountAppsCatalog_coastpay_description: 'Tarjetas de combustible y pagos de flota',
    accountAppsCatalog_coastpay_apiKeyHelp: 'La encuentra en CoastPay en Integrations > API Keys.',
};
